var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-left"},[_c('div',{},[_c('div',{staticClass:"row"},[_c('Chat',{staticClass:"col-12",attrs:{"order":_vm.order}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }